import clsx from 'clsx'
import PercentageCircle, { PercentageCircleProps } from 'components/leadEstimator/PercentageCircle'
import style from './StatListCircles.module.css'

interface Props {
    stats?: (PercentageCircleProps & { name: string })[]
    className?: string
}

const StatListCircles = ({ stats = [], className = '' }: Props) => {
    return (
        <div className={clsx(style.root, className)}>
            {stats.map((props, i) => (
                <div key={i}>
                    <PercentageCircle {...props} />
                    {props.name}
                </div>
            ))}
        </div>
    )
}

export default StatListCircles
